import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { sickNoteQKeys } from "@hooks/queries/sickNote/queryKey";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { SickNote } from "@customTypes/sickNote";


export const useCreateSickNote = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (sickNote: Partial<SickNote>) => {
      return api.post("sick_notes/", {
        start_date: sickNote.startDate,
        end_date: sickNote.endDate,
        patient_id: sickNote.patientId,
        consultation_id: sickNote.consultationId,
      });
    },
    onSuccess: (_, variables) => {
      // console.log(variables);
      showSuccessNotification({
        title: "success",
        message: "create-sick-note-success",
      });
      queryClient.invalidateQueries({
        queryKey: sickNoteQKeys.patient(variables.patientId as string),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Sick Note]", res);

      handleErrors(res, "mutation");
    },
  });
};
